import { render, staticRenderFns } from "./ASedes.vue?vue&type=template&id=86da5314"
import script from "./ASedes.vue?vue&type=script&lang=js"
export * from "./ASedes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports